import type { JSX } from 'react';
import type { OsaReferralReadData } from '@common/validation/customControls/osas/osasReferralSchemas/osasReferralReadSchema';
import type { ComponentsMap } from '@frontend/formEngine/readForm/readForm.types';
import { ServiceCode } from '@common/enums';
import { CustomControlMode } from '@common/enums/serviceWorkflow';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { useProcessActivityReadContext } from '@frontend/utils';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { ProcessActivityReadContext } from '../../../carePath/process/processActivity/processActivityRead/processActivityReadContext';
import { PatientInsurance } from '../../patientInsurance/PatientInsurance';
import { OsasFollowingSteps } from './components/osasFollowingSteps';
import { getOsasReferralReadComponents } from './components/util/getOsasReferralReadComponents';

export function OsasReferralRead(): JSX.Element {
    const { readSections } = useDefinedContext(ProcessActivityReadContext);
    const { processActivity } = useProcessActivityReadContext<OsaReferralReadData>();

    return (
        <>
            <PatientInsurance
                isPatientInformed={processActivity.customControlData.isPatientInformed}
                mode={CustomControlMode.read}
                serviceCode={ServiceCode.OSAS}
            />
            <ReadForm components={getComponents()} />
            <OsasFollowingSteps />
        </>
    );

    function getComponents(): ComponentsMap {
        return getOsasReferralReadComponents(readSections, processActivity.id);
    }
}
